import ConnectorTypeContainer from "./ConnectorTypeContainer";
import ConnectorTypeStore from "./ConnectorTypeStore";

export default ConnectorTypeStore(ConnectorTypeContainer); 
// export default (ConnectorTypeContainer); 